/**
 * Created by zad on 17/11/15.
 */
import Modal from './Modal';
import Confirm from './ModalConfirm';
import Button from './ModalButton';
import Prompt from './ModalPrompt';
import Alert from './ModalAlert';
import Open from './ModalOpen';

Modal.Prompt = Prompt;
Modal.Confirm = Confirm;
Modal.Alert = Alert;
Modal.Button = Button;
Modal.open = Open;

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.js